import { PicklistEventType } from '@warebee/frontend/data-access-api-graphql';
import { TwTheme } from '../../../../Tw';
import { getBestContrastColor } from '../../../common/color.helper';

const colors = TwTheme.extend.colors;

export type RouteSide = 'LEFT' | 'RIGHT' | undefined;

export function getSideOffset(side: RouteSide, isBackground = false): number {
  if (!side) return 0;
  // Adjust these values as needed for your design
  if (side === 'LEFT') {
    return isBackground ? 20 : 20;
  }
  else if (side === 'RIGHT') {
    return isBackground ? -20 : -20;
  }
  return 0;
}

export interface EventCircleStyle {
  radius: number;
  strokeWidth: number;
  stroke: string;
  fill: string;
  opacity: number;
  isDashed: boolean;
  dashPattern?: number[];
}

export function getEventCircleStyle(
  eventType?: PicklistEventType,
  baseColor = colors.events.travellingHorizontalStart,
): EventCircleStyle {
  const baseStyle: EventCircleStyle = {
    radius: 60,
    strokeWidth: 4,
    stroke: baseColor,
    fill: baseColor,
    opacity: 0.85,
    isDashed: false,
  };

  switch (eventType) {
    case PicklistEventType.TRAVELLING_HORIZONTAL_START:
      return {
        ...baseStyle,
        radius: 70,
        strokeWidth: 6,
        stroke: getBestContrastColor(colors.events.travellingHorizontalStart),
        fill: colors.events.travellingHorizontalStart,
        opacity: 0.9,
        isDashed: false,
      };

    case PicklistEventType.TRAVELLING_HORIZONTAL_END:
      return {
        ...baseStyle,
        radius: 70,
        strokeWidth: 6,
        stroke: getBestContrastColor(colors.events.travellingHorizontalEnd),
        fill: colors.events.travellingHorizontalEnd,
        opacity: 0.9,
        isDashed: true,
        dashPattern: [10, 5],
      };

    default:
      return baseStyle;
  }
}

export function getTimelineOffset(
  eventIndex: number,
  side: RouteSide,
  timelineSpacing = 100,
): { x: number; y: number } {
  const xBase = getSideOffset(side, false);
  const yOffset = eventIndex * timelineSpacing;

  return {
    x: xBase,
    y: yOffset,
  };
}

export function getCompactCircleStyle(
  eventType?: PicklistEventType,
  baseColor?: string,
  isCompactMode = false,
): EventCircleStyle {
  const style = getEventCircleStyle(eventType, baseColor);

  if (isCompactMode) {
    return {
      ...style,
      radius: style.radius * 0.6, // 40% smaller
      strokeWidth: style.strokeWidth * 0.5,
    };
  }

  return style;
}

export type VisibilityMode = 'normal' | 'timeline' | 'compact' | 'stacked';

export function getEventPosition(
  event: { x: number; y: number; locationSide?: string },
  eventIndex: number,
  mode: VisibilityMode = 'normal',
): { x: number; y: number } {
  const side = (event.locationSide || undefined) as RouteSide;
  const baseOffset = getSideOffset(side, false);

  switch (mode) {
    case 'timeline':
      console.log('timeline', eventIndex, side);
      const timeline = getTimelineOffset(eventIndex, side);
      return { x: event.x + timeline.x, y: event.y + timeline.y };

    case 'stacked':
      return {
        x: event.x + baseOffset,
        y: event.y + eventIndex * 80, // Stack vertically
      };

    case 'compact':
    case 'normal':
    default:
      return { x: event.x + baseOffset, y: event.y };
  }
}
